<template>
  <div class="create-account-page overflow-x-hide">
    <div class="container no-padding">
      <div class="row no-margin">
        <div class="col-md-12" :style="{ 'min-height': dyn_height }">
          <headerlogo :page-type="'1'" :light_logo="true" />

          <div
            class="row no-padding main-body h-100"
            :style="{ height: windowHeight }"
          >
            <div class="col-md-12 flex-container">
              <brandpattern page="CREATEACCOUNT" />
            </div>
          </div>
        </div>

        <errorhandler
          v-if="showProspectCallbackError || null"
          :prospect-callback-error-msg="prospectCallbackErrorMsg"
          @reset-show-prospect-callback-error="resetShowProspectCallbackError"
        />

        <!-- Create account Modal -->
        <div
          id="createAccountModal"
          class="modal fade create-account-modal"
          data-bs-backdrop="false"
          data-bs-keyboard="false"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="onClickClose"
                >
                  <img src="@/assets/img/close.svg" />
                </button>
              </div>
              <div class="modal-body account-modal">
                <div class="modal-body-sec1">
                  {{ getUiText("user-create-heading-1") }}
                </div>
                <div class="account-modal-text">
                  {{ getUiText("user-create-heading-sub-1") }}
                </div>
                <div class="password-group">
                  <label for="id" class="control-label input-label-password">{{
                    getUiText("user-create-create-password-heading-1")
                  }}</label>
                  <div class="password-sec">
                    <input
                      id="psw"
                      ref="pwd"
                      data-cy="psp-create-account-password-input"
                      type="password"
                      class="form-control form-control-lg password-input"
                      :placeholder="passwordPlaceholder"
                      tabindex="0"
                      @keyup.enter="submitPassword"
                      @keyup="keyMonitor"
                    />
                    <span class="show-password pr-3" @click="togglePassword">
                      <img
                        v-if="!enable_showpassword || null"
                        src="@/assets/img/eye-view.svg"
                      />
                      <img
                        v-else-if="enable_showpassword || null"
                        src="@/assets/img/eye-view-bright.svg"
                      />
                      <span
                        class="show-password-label"
                        :class="enable_showpassword ? 'enabled' : 'disabled'"
                        >{{
                          getUiText("user-create-create-password-show-1")
                        }}</span
                      >
                    </span>
                  </div>
                </div>
                <div class="password-text">
                  <div class="password-text-sec1">
                    {{ getUiText("user-create-guidance-heading-1") }}
                  </div>
                  <div class="row password-conditions mt-2">
                    <div class="col-md-6">
                      <ul class="p-0 password-left-conditions">
                        <li
                          v-for="item in getUiText(
                            'user-create-guidance-text-1',
                            true,
                          )"
                          :key="item"
                        >
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6">
                      <ul class="p-0">
                        <li
                          v-for="item in getUiText(
                            'user-create-guidance-text-2',
                            true,
                          )"
                          :key="item"
                        >
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="create-acc-btn">
                  <button
                    type="button"
                    class="btn btn-primary getstarted-button"
                    data-cy="psp-create-account-getstarted-button"
                    :disabled="disableButton"
                    @click="submitPassword"
                  >
                    {{ getUiText("user-create-button-create-account-1") }}
                  </button>
                </div>
              </div>
              <div class="modal-footer">
                <div class="modal-sec6">
                  <div class="modal-sec6-sec1">
                    <v-runtime-template :template="footerText" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Watch } from "vue-facing-decorator";
import HeaderLogo from "@/components/common/headerLogo.vue";
import BrandPattern2 from "@/components/prospect/brandPattern/brandPattern2.vue";
import $ from "jquery";
import ProspectService from "@/services/prospect/prospectService";
import errorhandler from "@/components/common/exceptionHandler.vue";
import Utils, { passwordHash } from "@/utils/utilities";
import { load } from "recaptcha-v3";
import VRuntimeTemplate from "vue3-runtime-template";
import store from "@/store";
import { localStorageBoolean, localStorageKey } from "@/utils/constants";
import { Modal } from "bootstrap";

@Component({
  components: {
    headerlogo: HeaderLogo,
    brandpattern: BrandPattern2,
    errorhandler,
    VRuntimeTemplate,
  },
})
export default class ProspectCreateAccount extends Vue {
  dyn_height = "0";
  disableButton = true;
  windowHeight = "";
  showPassword = false;
  enable_showpassword = false;
  public showProspectCallbackError = false;
  public prospectCallbackErrorMsg = "";
  createAccountModalInstance: any = null;

  public passwordPlaceholder = "";
  public footerText = "";
  public footerTextTags: any = {
    "user-create-button-create-account-1": {
      openTag: "<strong>",
      closeTag: "</strong>",
    },
    "user-create-footer-link-tc-1": {
      openTag: '<a href="javascript:void(0)">',
      closeTag: "</a>",
    },
    "user-create-footer-link-pp-1": {
      openTag: '<a href="javascript:void(0)">',
      closeTag: "</a>",
    },
  };

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }
  get passwordIV() {
    return store.state.LanguagePicker.pwdFeIv;
  }

  @Watch("languageSelected")
  onChangeLanguageSelected() {
    setTimeout(() => {
      this.updateUIVariables();
    }, 50);
  }

  get heightSetter() {
    return { "min-height": `${this.windowHeight}` };
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.onResize();
    });

    const responseModal = document.getElementById("createAccountModal");
    if (responseModal) {
      this.createAccountModalInstance = new Modal(responseModal);
      this.createAccountModalInstance.show();
    }

    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg");
    }

    this.updateUIVariables();
    this.setLanguages();
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  getProcessedUIText(id: string, tags: any) {
    return Utils.getProcessedUIText(
      id,
      tags,
      this.languageSelectedText,
      this.defaultUiText,
    );
  }

  updateUIVariables() {
    this.passwordPlaceholder = this.getUiText(
      "user-create-create-password-prompt-1",
    );
    this.footerText =
      "<span>" +
      this.getProcessedUIText(
        "user-create-footer-text-1",
        this.footerTextTags,
      ) +
      "</span>";
  }

  async setLanguages() {
    if (
      localStorage.getItem(localStorageKey.languagesData) == null ||
      localStorage.getItem(localStorageKey.languageList) == null ||
      this.passwordIV === ""
    ) {
      await Utils.getV3Recaptcha().then(
        async (finalKey: any) => {
          const captchKey = finalKey;
          const recaptcha = await load(`${captchKey}`, {
            autoHideBadge: true,
          });
          recaptcha.execute("submit").then((token) => {
            this.$store.dispatch("LanguagePicker/setLanguages", token);
          });
          recaptcha.execute("submit").then((token) => {
            this.$store.dispatch("LanguagePicker/setLanguageList", token);
          });
        },
        (error: any) => {
          if (
            error &&
            error.data &&
            error.data.error &&
            error.data.error.type
          ) {
            if (error.data.error.type === "exc_session_invalid-1") {
              sessionStorage.setItem(
                "prospectCallbackErrorInfo",
                JSON.stringify(error.data.error),
              );
              this.$router.push({ path: "/" });
            } else {
              this.showErrorInfo(error.data.error);
            }
          } else if (error.data.message === "invalid csrf token") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data);
          }
        },
      );
    }
  }

  onResize() {
    this.dyn_height = (window.innerHeight + "px") as string;
    this.windowHeight = "" + window.innerHeight + "px !important ";
    $(this.$refs.pwd as any).focus();
  }
  togglePassword() {
    if (!this.enable_showpassword) return;
    this.showPassword = !this.showPassword;
    const input_type =
      $(this.$refs.pwd as any).attr("type") === "password"
        ? "text"
        : "password";
    $(this.$refs.pwd as any).attr("type", input_type);
  }

  async submitPassword() {
    if (this.disableButton) {
      return;
    }
    const prospectService = new ProspectService();
    const password: any = $(this.$refs.pwd as any).val();

    const passwordValue = await passwordHash(password, this.passwordIV);

    prospectService.savePassword(`%s${this.passwordIV}.${passwordValue}`).then(
      () => {
        localStorage.removeItem("csrfReloadDone");
        this.$router.push({ path: "/user/login" });
      },
      (error: any) => {
        if (error && error.data && error.data.error && error.data.error.type) {
          if (error.data.error.type === "exc_session_invalid-1") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data.error),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data.error);
          }
        } else if (error.data.message === "invalid csrf token") {
          if (localStorage.getItem("csrfReloadDone") == null) {
            localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
            this.$router.go(0);
          }
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data),
          );
          this.$router.push({ path: "/" });
        } else {
          this.showErrorInfo(error.data);
        }
      },
    );
  }

  keyMonitor() {
    const myInput: any = document.getElementById("psw");
    this.enable_showpassword = myInput.value.length > 0 ? true : false;
    let pattern = /(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}/g;
    if (myInput.value.match(pattern)) {
      this.disableButton = false;
    } else {
      this.disableButton = true;
    }
  }

  showErrorInfo(errorInfo: any) {
    if (errorInfo && errorInfo !== "") {
      errorInfo =
        typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
      if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
        this.showProspectCallbackError = true;
        this.prospectCallbackErrorMsg = errorInfo.message;
      }
    }
  }

  onClickClose() {
    this.$router.go(-1);
  }
  resetShowProspectCallbackError() {
    this.showProspectCallbackError = false;
    this.prospectCallbackErrorMsg = "";
  }
  beforeUnmount() {
    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg page-shadow");
    }
  }
}
</script>

<style lang="scss" scoped>
.create-account-page {
  background: #387dff;

  .form-control:focus {
    box-shadow: none;
  }
  .form-control::placeholder {
    color: #b7b7b7;
    font-size: 22px;
  }
  .modal {
    pointer-events: none;
  }
  .modal-backdrop {
    display: none;
  }

  .create-account-modal {
    width: 100%;
    height: 100%;
    pointer-events: none;
    .modal-dialog {
      transition: none;
    }
    .modal-header {
      border: none;
      padding: 10px 10px 0px 10px;
      justify-content: flex-end;
      .close {
        float: right;
        opacity: 1;
        margin-right: 10px;
        margin-top: 10px;
        position: relative;
        padding: 0;
        z-index: 999;

        img {
          width: 19px;
          height: 19px;
        }
      }
    }

    .modal-content {
      box-shadow: 2px 0px 20px rgba(33, 31, 88, 0.1);
      border-radius: 6px;
      border: none;
    }

    .modal-body {
      padding: 25px 70px 48px 70px;

      .flex-container {
        position: absolute;
        bottom: 0px;
        height: 100%;
      }

      .modal-body-sec1 {
        color: #0345bd;
        font-size: 26px;
        font-weight: 600;
        line-height: 39px;
      }

      .account-modal-text {
        font-size: 15px;
        color: #231f20;
        line-height: 22px;
        font-weight: 400;
        margin-top: 15px;
      }

      .password-text {
        color: #878787;
        font-size: 12px;
        margin-top: 41px;
      }

      .password-text-sec1 {
        color: #231f20;
      }
      .create-acc-btn {
        margin-top: 38px;
      }

      .input-label-password {
        font-weight: 500;
        font-size: 12px;
        color: #231f20;
        line-height: 18px;
      }
      .password-input {
        border: none;
        font-style: normal;
        font-weight: 300;
        font-size: 22px;
        line-height: 33px;
        color: #0345bd;
        border-left: 1px solid rgba(183, 183, 183, 0.3);
        border-radius: unset;
      }
      .password-group {
        margin-top: 48px;

        label {
          margin-bottom: 14px;
        }
        .password-sec {
          display: flex;
        }
      }
      .password-conditions {
        margin-left: 0px;
        margin-right: 0px;
      }

      .password-left-conditions {
        margin-bottom: 0px;
      }

      .getstarted-button {
        width: 212px;
        height: 45px;
        left: 72px;
        box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
        border-radius: 29.4638px;
        background: #0345bd;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 27px;
        text-transform: uppercase;
      }

      .create-acc-btn button:disabled {
        color: #ffffff;
        background: #eeeff0;
        border-color: #eeeff0;
      }

      .show-password {
        display: flex;
        cursor: pointer;
        padding-left: 10px;
        min-width: 100px;
        width: fit-content;

        img {
          padding-right: 5px;
          float: right;
        }

        .show-password-label {
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
          text-align: right;
          margin-top: 16px;
        }
        .disabled {
          color: #b7b7b7;
        }
        .enabled {
          color: #0345bd;
        }
      }
    }
    .modal-footer {
      background: linear-gradient(
        180deg,
        rgba(230, 230, 230, 0.38) 0%,
        #ffffff 58.06%
      );
      padding: 26px 70px;
      font-size: 12px;

      .modal-sec6-sec1 {
        line-height: 20.4px;
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 767px) {
  .create-account-page {
    .create-account-modal {
      .modal-header {
        .close {
          margin-top: 3px !important;
          img {
            width: 17px;
            height: 17px;
          }
        }
      }
      .modal-body {
        padding: 18px 30px 30px 30px;

        .modal-body-sec1 {
          font-size: 22px;
        }

        .password-group {
          margin-top: 24px !important;
        }
        .getstarted-button {
          font-size: 16px;
          line-height: 24px;
        }
        .password-input {
          font-size: 18px;
          padding-right: 0px;
        }
        .password-input::placeholder {
          font-size: 18px;
        }

        .show-password .show-password-label {
          margin-top: 12px;
        }
        .input-label-password {
          font-size: 12px;
          line-height: 18px;
        }

        .account-modal-text {
          font-size: 15px !important;
          line-height: 22px !important;
          margin-top: 8px !important;
        }
        .password-text {
          margin-top: 22px;
        }
        .create-acc-btn {
          margin-top: 20px;
        }
      }
      .modal-footer {
        padding: 10px 30px;
      }
    }
  }
}

@media (max-height: 500px) {
  .modal {
    padding-top: 50px;
  }
}
@media (min-width: 3840px) {
  .create-account-page {
    .create-account-modal {
      .form-control:focus {
        padding-left: 30px;
        font-size: 38px;
        line-height: 30px;
      }
      .modal-dialog {
        max-width: 1090px !important;
      }
      .modal-body {
        padding: 40px 90px 90px 90px;
      }
      .modal-content {
        border-radius: 15px !important;
      }
      .modal-body-sec1 {
        font-size: 52px !important;
        line-height: 78px !important;
      }
      .account-modal-text {
        font-size: 30px !important;
        line-height: 44px !important;
      }
      .password-group {
        margin-top: 90px !important;
      }
      .input-label-password {
        font-size: 24px !important;
        line-height: 36px !important;
        margin-bottom: 28px !important;
      }

      .show-password {
        padding-left: 20px !important;

        img {
          zoom: 2.2;
        }
      }

      .show-password-label {
        font-size: 24px !important;
        margin-top: 31px !important;
      }

      .close {
        margin-right: 35px !important;
        margin-top: 40px !important;

        img {
          height: 30px !important;
          width: 30px !important;
        }
      }

      .create-acc-btn {
        margin-top: 76px !important;
      }
      .password-input {
        font-size: 44px !important;
        padding-left: 30px;
      }
      .password-input::placeholder {
        font-size: 44px !important;
      }
      .password-text {
        font-size: 24px !important;
        margin-top: 82px !important;
      }

      .modal-sec6-sec1 {
        line-height: 40.8px !important;
      }

      .modal-footer {
        font-size: 20px !important;
        padding: 35px 100px;
      }

      .getstarted-button {
        width: 390px !important;
        height: 90px !important;
        font-size: 30px !important;
        border-radius: 41px !important;
      }
    }
  }
}
</style>
